export default __webpack_public_path__ + "static/media/IFERN-LOGO.ad350a99.jpg";